var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":"Add Instruction","inputs-map":_vm.form,"save-cb":_vm.saveInstruction}})
}
var staticRenderFns = []

export { render, staticRenderFns }